// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2asZv","comment":"styles_comment__3doZL"};